<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7,14C7,14,2,14,2,14C2,14,2,2,2,2C2,2,7,2,7,2C7.55,2,8,1.55,8,1C8,0.45,7.55,0,7,0C7,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,7,16,7,16C7.55,16,8,15.55,8,15C8,14.45,7.55,14,7,14C7,14,7,14,7,14ZM15.71,7.29C15.71,7.29,12.71,4.29,12.71,4.29C12.53,4.11,12.28,4,12,4C11.45,4,11,4.45,11,5C11,5.28,11.11,5.53,11.29,5.71C11.29,5.71,12.59,7,12.59,7C12.59,7,6,7,6,7C5.45,7,5,7.45,5,8C5,8.55,5.45,9,6,9C6,9,12.59,9,12.59,9C12.59,9,11.3,10.29,11.3,10.29C11.11,10.47,11,10.72,11,11C11,11.55,11.45,12,12,12C12.28,12,12.53,11.89,12.71,11.71C12.71,11.71,15.71,8.71,15.71,8.71C15.89,8.53,16,8.28,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,15.71,7.29,15.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LogOut',
} as DefineComponent
</script>
